import { XIcon } from 'lucide-react';
import { Activity } from 'react';

import { Badge } from '@/ux-common/components/badge/badge';
import { Button } from '@/ux-common/components/button/button';
import {
  Header,
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
} from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';
import { cn } from '@/ux-common/lib/utils';

interface EquipmentBulkEditHeaderProps {
  deviceCount: number;
  isPushOutOpen: boolean;
  onClose: () => void;
  title: string;
}

export const EquipmentBulkEditHeader = ({
  deviceCount,
  isPushOutOpen,
  onClose,
  title,
}: EquipmentBulkEditHeaderProps) => {
  return (
    <Header>
      <HeaderIcon>
        <Badge className={cn('badge badge-default badge-pill')}>{deviceCount}</Badge>
      </HeaderIcon>
      <HeaderTitle>
        <Typography as="p" className="text-body text-primary uppercase leading-none">
          {title}
        </Typography>
      </HeaderTitle>
      <Activity mode={isPushOutOpen ? 'hidden' : 'visible'}>
        <HeaderActions>
          <Button className="btn btn-tier2 btn-md btn-circle" onClick={onClose} aria-label="Close">
            <XIcon className="btn-icon" aria-hidden="true" />
          </Button>
        </HeaderActions>
      </Activity>
    </Header>
  );
};
